import { Component, OnInit } from '@angular/core';
import { PruHttpService } from '../../../services/pru-http.service';
import { SessionStorageService } from '../../../services/web-storage/session-storage.service';
import { GenericService } from '../../../services/generic.service';

declare var environment: any;
@Component({
  selector: 'ret-additonal-accounts',
  templateUrl: './additonal-accounts.component.html',
  styleUrls: ['./additonal-accounts.component.scss']
})
export class AdditonalAccountsComponent implements OnInit {
  numOfAddlAccounts: number = 0;
  AddlAccounts: Array<any> = [];
  ACUrls = {
    "flexible deferral (new leo)": environment.Ret_AC_URL_leo,
    "silgan total benefits": environment.Ret_AC_URL_silgan,
    "self-directed account": environment.Ret_AC_URL_SDB,
    "self-managed account": environment.CUSAML_DOMAIN + "/idp/startSSO.ping?PartnerSpId=http://www.netxinvestor.com",
    "individually directed account": "https://sso.uboc.com/obc/forms/login.fcc",
    "ira": "https://www.wealthscapeinvestor.com/pru",
    "after tax brokerage": "https://www.wealthscapeinvestor.com/pru",
    "view other accounts": "/myprurouting?alias=ac_view_other",
    "philips pension plan": environment.CUSAML_DOMAIN + "/idp/startSSO.ping?PartnerSpId=" + environment.Ret_Morneaushepell_ID + "%2Fsaml2.0&rtnURL=" + environment.RETIREMENT_DOMAIN + "&univlPlanId=${upid}",
    "philips health savings account (hsa)": environment.CUSAML_DOMAIN + "/idp/startSSO.ping?PartnerSpId=my.healthequity.com&univlPlanId=${upid}",
    "philips employee stock purchase plan (espp)": environment.CUSAML_DOMAIN + "/idp/startSSO.ping?PartnerSpId=external-ip.computershare.com&univlPlanId=${upid}",
    "personal choice retirement account": environment.CUSAML_DOMAIN + "/idp/startSSO.ping?PartnerSpId=PrudentialRBS"
  };

  constructor(private _pruHttp: PruHttpService, private _genericService: GenericService, private _sessionStorage: SessionStorageService) { }

  ngOnInit() {
    let sessionACs = this._sessionStorage.getItem('AddlAccounts', true);
    if (sessionACs) {
      this.numOfAddlAccounts = sessionACs.numOfAddlAccounts;
      this.AddlAccounts = sessionACs.AddlAccounts;
    } else {
      let customHeaders = {
        "X-PruBU-RET-ApplicationKey": "WEB",
        "X-PruBU-RET-UserType": this._genericService.usr_csr ? 'I' : 'P'
      };
      this._pruHttp.get('/retirement/v1/user/additionalAccounts', 'retirement-additional-accounts', null, customHeaders)
        .subscribe(
          (res: any) => {
            if (res.responseData) {
              this.numOfAddlAccounts = res.responseData.numOfAddlAccounts ? parseInt(res.responseData.numOfAddlAccounts) : 0;
              if (this.numOfAddlAccounts > 0) {
                res.responseData.addlAccounts.forEach(element => {
                  if (/self-directed account/i.test(element.acctName)) {
                    element.ACurl = this.ACUrls['self-directed account'];
                  } else if (/self-managed account/i.test(element.acctName)) {
                    element.ACurl = this.ACUrls['self-managed account'];
                  } else {
                    element.ACurl = this.ACUrls[element.acctName.toLowerCase()];
                  }
                  element.ACurl = element.ACurl ? element.ACurl.replace('${upid}', `${element.univlPlanId}`) : element.ACurl
                  this.AddlAccounts.push(element);
                });
              }
              this._sessionStorage.setItem("AddlAccounts", { numOfAddlAccounts: this.numOfAddlAccounts, AddlAccounts: this.AddlAccounts }, true);
            }
          }
        );
    }
  }
}